import { createContext, useContext } from 'react';

/**
 * Shared context for the SideShell panel stack. Lives in its own file so the
 * `SideShell.Panel` chrome can pop the stack without importing `side-shell.tsx`
 * (which imports the panel back) — avoiding a circular import.
 */
type SideShellContextValue = {
  // Pops the top of the panel stack (back to the previous panel, or the default
  // `children` when the last panel is popped).
  goBack: () => void;
};

export const SideShellContext = createContext<SideShellContextValue | null>(
  null
);

export const useSideShellContext = () => useContext(SideShellContext);
